import { useState, useEffect } from 'react';
import { Stack, Container, Typography, Card, Box, Button, Chip, Paper, Grid, Avatar, Divider, alpha, useTheme } from '@mui/material';
import TableStyle from '../../ui-component/TableStyle';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { getApi } from 'views/services/api';
import { useNavigate } from 'react-router';
import {
  Receipt as ReceiptIcon,
  Person as PersonIcon,
  Restaurant as RestaurantIcon,
  Bed as BedIcon,
  AccountBalance as AccountBalanceIcon,
  Discount as DiscountIcon,
  TrendingUp as TrendingUpIcon,
  Description as DescriptionIcon,
  LocationOn as LocationIcon,
  Phone as PhoneIcon,
  LocalOffer as LocalOfferIcon,
  Assessment as AssessmentIcon
} from '@mui/icons-material';

const ViewInvoices = () => {
  const theme = useTheme();
  const hotelId = JSON.parse(localStorage.getItem('hotelData')).hotelId;
  const hotelData = JSON.parse(localStorage.getItem('hotelData'));
  const currency = hotelData?.currency || 'USD';
  console.log('hotelId =>', hotelId);

  const navigate = useNavigate();

  const [invoiceData, setInvoiceData] = useState([]);
  const [reservationIds, setReservationId] = useState([]);

  const fetchInvoiceData = async () => {
    try {
      console.log('in fetchInvoiceData ==>', `api/invoice/viewallinvoice/${hotelId}`);
      const response = await getApi(`api/invoice/viewallinvoice/${hotelId}`);
      console.log('response here =>', response);
      setInvoiceData(response?.data?.invoiceData);

      const reservationids = response.data.invoiceData.map((item) => item.reservationId);
      console.log('Reservation IDs =>', reservationids);
      setReservationId(reservationids);
    } catch (error) {
      console.log(error);
    }
  };
  console.log('fetchInvoiceData response=>', invoiceData);
  console.log('set ids ==>', reservationIds);

  const fetchSingleBillData = async () => {
    try {
      reservationIds.map(async (reservationId) => {
        const response = await getApi(`api/singleinvoice/view/${reservationId}`);
        console.log('for fetchSingleBillData res ==>', response);

        response?.data?.InvoiceData && setInvoiceData((prevData) => [...prevData, ...response.data.InvoiceData]);
      });
    } catch (error) {
      console.log(error);
    }
  };

  console.log('ha ha ==>', invoiceData);

  useEffect(() => {
    fetchInvoiceData();
  }, []);

  useEffect(() => {
    console.log('reservationIds=============>>>>>', reservationIds);
    if (reservationIds.length > 0) {
      fetchSingleBillData();
    }
  }, [reservationIds]);

  const handleGenerateBill = (billItem) => {
    console.log(billItem, 'billItem');
    if (billItem.type === 'room' || billItem.type === 'food') {
      navigate(`/roombill/view/${billItem._id}`);
    } else {
      navigate(`/singlebill/view/${billItem.reservationId}`);
    }
  };

  // Función para obtener el tipo de factura en español
  const getInvoiceType = (type) => {
    switch (type) {
      case 'room':
        return 'Habitación';
      case 'food':
        return 'Restaurante';
      case 'Food+Room':
        return 'Habitación + Restaurante';
      default:
        return 'Habitación + Restaurante';
    }
  };

  // Función para obtener el color del chip según el tipo
  const getTypeChipColor = (type) => {
    switch (type) {
      case 'room':
        return 'primary';
      case 'food':
        return 'warning';
      default:
        return 'secondary';
    }
  };

  // Calcular estadísticas
  const totalInvoices = invoiceData?.length || 0;
  const totalAmount =
    invoiceData?.reduce((sum, invoice) => {
      const amount = invoice.totalAmount || invoice.totalFoodAndRoomAmount || 0;
      return sum + amount;
    }, 0) || 0;
  const averageAmount = totalInvoices > 0 ? totalAmount / totalInvoices : 0;

  const columns = [
    {
      field: `invoiceNumber`,
      headerName: 'Nº Factura',
      flex: 1.2,
      cellClassName: 'name-column--cell name-column--cell--capitalize',
      renderCell: (params) => {
        return (
          <Box
            onClick={() => handleGenerateBill(params?.row)}
            sx={{
              cursor: 'pointer',
              '&:hover': {
                color: theme.palette.primary.main,
                fontWeight: 600
              }
            }}
          >
            <Stack direction="row" alignItems="center" spacing={1}>
              <ReceiptIcon sx={{ fontSize: 16, color: theme.palette.primary.main }} />
              <Typography variant="body2" fontWeight={500} color="primary">
                {params.value}
              </Typography>
            </Stack>
          </Box>
        );
      }
    },
    {
      field: `name`,
      headerName: 'Cliente',
      flex: 1.5,
      cellClassName: ' name-column--cell--capitalize',
      renderCell: (params) => {
        return (
          <Box>
            <Stack direction="row" alignItems="center" spacing={1.5}>
              <Avatar
                sx={{
                  width: 32,
                  height: 32,
                  bgcolor: alpha(theme.palette.primary.main, 0.1),
                  color: theme.palette.primary.main,
                  fontSize: '0.875rem'
                }}
              >
                {params.value?.charAt(0)?.toUpperCase()}
              </Avatar>
              <Box>
                <Typography variant="body2" fontWeight={500}>
                  {params.value}
                </Typography>
                <Stack direction="row" alignItems="center" spacing={0.5}>
                  <PhoneIcon sx={{ fontSize: 12, color: theme.palette.text.secondary }} />
                  <Typography variant="caption" color="text.secondary">
                    {params.row.customerPhoneNumber}
                  </Typography>
                </Stack>
              </Box>
            </Stack>
          </Box>
        );
      }
    },
    {
      field: 'address',
      headerName: 'Dirección',
      flex: 1.3,
      renderCell: (params) => (
        <Stack direction="row" alignItems="center" spacing={0.5}>
          <LocationIcon sx={{ fontSize: 14, color: theme.palette.text.secondary }} />
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}
          >
            {params.value || 'No especificada'}
          </Typography>
        </Stack>
      )
    },
    {
      field: 'type',
      headerName: 'Tipo',
      flex: 1,
      renderCell: (params) => {
        const type = params.row.type || 'Food+Room';
        return (
          <Chip
            label={getInvoiceType(type)}
            color={getTypeChipColor(type)}
            size="small"
            variant="outlined"
            sx={{
              borderRadius: 2,
              fontWeight: 500,
              fontSize: '0.75rem'
            }}
          />
        );
      }
    },
    {
      field: 'foodAmount',
      headerName: 'Monto Restaurante',
      flex: 1.2,
      renderCell: (params) => {
        const amount = params.row.totalFoodAmount || params.row.foodAmount;
        return (
          <Box display="flex" alignItems="center">
            {amount ? (
              <>
                <RestaurantIcon sx={{ fontSize: 14, mr: 0.5, color: theme.palette.warning.main }} />
                <Typography variant="body2" fontWeight={500}>
                  {currency} {amount.toLocaleString()}
                </Typography>
              </>
            ) : (
              <Typography variant="body2" color="text.secondary">
                N/A
              </Typography>
            )}
          </Box>
        );
      }
    },
    {
      field: 'roomRent',
      headerName: 'Monto Habitación',
      flex: 1.2,
      renderCell: (params) => {
        const amount = params.row.totalRoomAmount || params.row.roomRent;
        return (
          <Box display="flex" alignItems="center">
            {amount ? (
              <>
                <BedIcon sx={{ fontSize: 14, mr: 0.5, color: theme.palette.primary.main }} />
                <Typography variant="body2" fontWeight={500}>
                  {currency} {amount.toLocaleString()}
                </Typography>
              </>
            ) : (
              <Typography variant="body2" color="text.secondary">
                N/A
              </Typography>
            )}
          </Box>
        );
      }
    },
    {
      field: 'advanceAmount',
      headerName: 'Anticipo',
      flex: 1,
      renderCell: (params) => {
        const amount = params.row.advanceAmount;
        const hasRoomAmount = params.row.totalRoomAmount;

        return (
          <Box display="flex" alignItems="center">
            {amount && !hasRoomAmount ? (
              <>
                <AccountBalanceIcon sx={{ fontSize: 14, mr: 0.5, color: theme.palette.success.main }} />
                <Typography variant="body2" fontWeight={500} color="success.main">
                  {currency} {amount.toLocaleString()}
                </Typography>
              </>
            ) : (
              <Typography variant="body2" color="text.secondary">
                N/A
              </Typography>
            )}
          </Box>
        );
      }
    },
    {
      field: 'discount',
      headerName: 'Descuento',
      flex: 1,
      renderCell: (params) => {
        return (
          <Box display="flex" alignItems="center">
            {params.value ? (
              <>
                <DiscountIcon sx={{ fontSize: 14, mr: 0.5, color: theme.palette.error.main }} />
                <Typography variant="body2" fontWeight={500} color="error.main">
                  {currency} {params.value.toLocaleString()}
                </Typography>
              </>
            ) : (
              <Typography variant="body2" color="text.secondary">
                N/A
              </Typography>
            )}
          </Box>
        );
      }
    },
    {
      field: 'totalAmount',
      headerName: 'Total',
      flex: 1.2,
      renderCell: (params) => {
        const total = params.row.totalAmount || params.row.totalFoodAndRoomAmount;
        return (
          <Chip
            label={`${currency} ${total?.toLocaleString()}`}
            color="primary"
            variant="filled"
            sx={{
              borderRadius: 2,
              fontWeight: 600,
              fontSize: '0.875rem',
              minWidth: 80
            }}
          />
        );
      }
    }
  ];

  return (
    <>
      <Container maxWidth="xl" sx={{ py: 3 }}>
        {/* Header Section */}
        <Paper
          elevation={0}
          sx={{
            p: 3,
            mb: 3,
            background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
            color: 'white',
            borderRadius: 3
          }}
        >
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Box>
              <Typography variant="h4" fontWeight={700} gutterBottom>
                Gestión de Facturas
              </Typography>
              <Typography variant="body1" sx={{ opacity: 0.9 }}>
                Administra todas las facturas de clientes del hotel
              </Typography>
            </Box>
            <Box sx={{ display: { xs: 'none', md: 'block' } }}>
              <DescriptionIcon sx={{ fontSize: 60, opacity: 0.3 }} />
            </Box>
          </Stack>
        </Paper>

        {/* Statistics Cards */}
        <Grid container spacing={3} sx={{ mb: 3 }}>
          <Grid item xs={12} sm={4}>
            <Card
              sx={{
                p: 2.5,
                borderRadius: 3,
                border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: theme.shadows[8]
                }
              }}
            >
              <Stack direction="row" alignItems="center" spacing={2}>
                <Box
                  sx={{
                    width: 48,
                    height: 48,
                    borderRadius: 2,
                    backgroundColor: alpha(theme.palette.primary.main, 0.1),
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <AssessmentIcon sx={{ color: theme.palette.primary.main, fontSize: 24 }} />
                </Box>
                <Box>
                  <Typography variant="h6" fontWeight={600} color="primary">
                    {totalInvoices}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Total de Facturas
                  </Typography>
                </Box>
              </Stack>
            </Card>
          </Grid>

          <Grid item xs={12} sm={4}>
            <Card
              sx={{
                p: 2.5,
                borderRadius: 3,
                border: `1px solid ${alpha(theme.palette.success.main, 0.1)}`,
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: theme.shadows[8]
                }
              }}
            >
              <Stack direction="row" alignItems="center" spacing={2}>
                <Box
                  sx={{
                    width: 48,
                    height: 48,
                    borderRadius: 2,
                    backgroundColor: alpha(theme.palette.success.main, 0.1),
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <TrendingUpIcon sx={{ color: theme.palette.success.main, fontSize: 24 }} />
                </Box>
                <Box>
                  <Typography variant="h6" fontWeight={600} color="success.main">
                    {currency} {totalAmount.toLocaleString()}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Ingresos Totales
                  </Typography>
                </Box>
              </Stack>
            </Card>
          </Grid>

          <Grid item xs={12} sm={4}>
            <Card
              sx={{
                p: 2.5,
                borderRadius: 3,
                border: `1px solid ${alpha(theme.palette.info.main, 0.1)}`,
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: theme.shadows[8]
                }
              }}
            >
              <Stack direction="row" alignItems="center" spacing={2}>
                <Box
                  sx={{
                    width: 48,
                    height: 48,
                    borderRadius: 2,
                    backgroundColor: alpha(theme.palette.info.main, 0.1),
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <LocalOfferIcon sx={{ color: theme.palette.info.main, fontSize: 24 }} />
                </Box>
                <Box>
                  <Typography variant="h6" fontWeight={600} color="info.main">
                    {currency} {averageAmount.toLocaleString(undefined, { maximumFractionDigits: 0 })}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Promedio por Factura
                  </Typography>
                </Box>
              </Stack>
            </Card>
          </Grid>
        </Grid>

        {/* Data Table */}
        <TableStyle>
          <Card
            sx={{
              borderRadius: 3,
              overflow: 'hidden',
              border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
              '& .MuiDataGrid-root': {
                border: 'none',
                '& .MuiDataGrid-columnHeaders': {
                  backgroundColor: alpha(theme.palette.primary.main, 0.05),
                  borderBottom: `2px solid ${alpha(theme.palette.primary.main, 0.1)}`,
                  '& .MuiDataGrid-columnHeader': {
                    fontWeight: 600,
                    fontSize: '0.875rem'
                  }
                },
                '& .MuiDataGrid-row': {
                  '&:hover': {
                    backgroundColor: alpha(theme.palette.primary.main, 0.02)
                  }
                },
                '& .MuiDataGrid-cell': {
                  borderBottom: `1px solid ${alpha(theme.palette.divider, 0.05)}`
                }
              }
            }}
          >
            <Box sx={{ p: 3, pb: 1 }}>
              <Typography variant="h6" fontWeight={600} color="primary">
                Facturas de Clientes ({totalInvoices})
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Haz clic en el número de factura para ver los detalles completos
              </Typography>
            </Box>

            <Box sx={{ height: 600, width: '100%' }}>
              <DataGrid
                rows={invoiceData ?? []}
                columns={columns}
                getRowId={(row) => row._id}
                slots={{ toolbar: GridToolbar }}
                slotProps={{
                  toolbar: {
                    showQuickFilter: true,
                    quickFilterProps: {
                      debounceMs: 500,
                      placeholder: 'Buscar facturas...'
                    }
                  }
                }}
                sx={{
                  '& .MuiDataGrid-toolbarContainer': {
                    borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
                    p: 2
                  }
                }}
              />
            </Box>
          </Card>
        </TableStyle>
      </Container>
    </>
  );
};

export default ViewInvoices;
